import React from "react";
import moment from "moment";
import ArrowDown from "@material-ui/icons/KeyboardArrowDown";
import cs from "classnames";

import { DefaultButton as Button } from "../../Button";
import { Context } from "../../../context";
import games from "../../../../content/assets/icons/games.svg";
import calendar from "../../../../content/assets/icons/calendar.svg";

import helmet from "../../../../content/assets/icons/helmet.svg";
import Input from "../../Input";
import * as actions from "../../../actions";
import { DefaultCheckbox as Checkbox } from "../../Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const { useCountUp } =
  typeof window !== `undefined` ? require("react-countup") : {};

function format(val) {
  const formatter = new Intl.NumberFormat("ru-RU");
  return formatter.format(Math.abs(val || 0)).replace(".00", "");
}

const SideBar = ({
  classes,
  step,
  changeStep,
  changeSignupTrigger,
  changeOrderingDataSave,
}) => {
  const {
    state: { insurance, errors },
    dispatch,
  } = React.useContext(Context);
  const [promocode, onChangePromocode] = React.useState(
    insurance.promoCode || ""
  );
  const [sportsHidded, hideSports] = React.useState(true);
  const [promoHidden, hidePromo] = React.useState(true);
  const [agreedToTerms, agreeToTerms] = React.useState(false);

  const sendPromocode = () => {
    actions.updateInsurance(
      {
        id: insurance.id,
        update: {
          promoCode: promocode || "",
        },
      },
      dispatch
    );
  };

  const cancelPromocode = () => {
    actions.updateInsurance(
      {
        id: insurance.id,
        delete: {
          promoCode: true,
        },
      },
      dispatch
    );
  };

  const { countUp = 0, update } = useCountUp
    ? useCountUp({
        start: 0,
        end: insurance.totalPrice,
        duration: 0.5,
        delay: 100,
      })
    : {};

  update && update(insurance.totalPrice);

  let disabled = true;
  if (insurance.sports.length && insurance.coverage && step === 0) {
    disabled = false;
  }
  if (step === 1) {
    disabled = false;
  }
  if (
    insurance.creator.firstName &&
    insurance.creator.phone &&
    agreedToTerms &&
    insurance.creator.lastName &&
    insurance.creator.email &&
    step === 2
  ) {
    disabled = false;
  }
  const sortedSports = insurance.sports.sort((a, b) =>
    a.title.localeCompare(b.title)
  );
  return (
    <div className={`${classes.sidebar} sidebar`}>
      <div className="sidebar-container">
        <div className={`${classes.price}`}>
          <p>Стоимость:</p>
          <p className={classes.total}>{format(countUp || "0")}₽</p>
          <Button
            disabled={insurance.loading || disabled}
            classes={{ root: classes.nextButton }}
            onClick={() => {
              if (step === 2) {
                changeSignupTrigger(true);
              } else if (step === 1) {
                changeOrderingDataSave(true);
              } else {
                changeStep(step + 1);
              }
            }}
          >
            {step === 2 ? "Оплатить" : "Далее"}
          </Button>
          {step === 2 ? (
            <React.Fragment>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={() => {
                      agreeToTerms(!agreedToTerms);
                    }}
                    color="primary"
                  />
                }
                label="Cоглашаюсь с: "
                labelPlacement="end"
                disableRipple
                color="primary"
              />
              <br />
              <a
                target="_blank"
                href="https://storage.yandexcloud.net/static.moishlem.ru/docs/dogovor-oferta-obrazets.pdf"
              >
                договором-офертой
              </a>
              ,{" "}
              <a
                target="_blank"
                href="https://storage.yandexcloud.net/static.moishlem.ru/docs/pravila-dobrovolnogo-strahovaniya-klientov.pdf"
              >
                правилами страхования
              </a>
              ,{" "}
              <a
                target="_blank"
                href="https://storage.yandexcloud.net/static.moishlem.ru/docs/soglashenie-o-vzaimodejstvii.pdf"
              >
                соглашениями о взаимодействии
              </a>
              ,{" "}
              <a
                target="_blank"
                href="https://storage.yandexcloud.net/static.moishlem.ru/docs/soglasie-na-obrabotku-personalnyh-dannyh.pdf"
              >
                обработке персональных данных
              </a>
            </React.Fragment>
          ) : null}
          <div className={classes.promo}>
            {/* <FormControlLabel
              classes={{ root: classes.controlLabel }}
              control={
                <Switch
                  focusVisibleClassName={classes.focusVisible}
                  disableRipple
                  classes={{
                    root: classes.rootSwitch,
                    switchBase: classes.switchBase,
                    thumb: classes.thumb,
                    track: classes.track,
                    checked: classes.checked,
                  }}
                  checked={insurance.isCompetition}
                  value="competition"
                  onChange={changeCompetetion}
                />
              }
              label={insurance.isCompetition ? 'С соревнованиями' : 'Без соревнований' }
            /> */}

            {!insurance.promoCode ? (
              <div className={classes.promoInputContainer}>
                <p
                  onClick={() => {
                    hidePromo(!promoHidden);
                  }}
                >
                  У вас есть промокод?
                </p>
                <div
                  className={
                    (classes.promoInputForm,
                    promoHidden && classes.promoInputContainerShow)
                  }
                >
                  <Input
                    className={classes.promoInput}
                    onChange={({ target: { value } }) =>
                      onChangePromocode(value)
                    }
                    placeholder="Промокод"
                  />
                  <Button
                    className={classes.promoButton}
                    onClick={sendPromocode}
                  >
                    Ввести
                  </Button>
                </div>
              </div>
            ) : (
              <React.Fragment>
                <p>
                  <b>Промокод верен</b>
                </p>
                <Button
                  className={classes.promoButton}
                  onClick={cancelPromocode}
                >
                  Удалить
                </Button>
              </React.Fragment>
            )}
            {/* <Input type='checkbox' placeholder='Телемедицина'/> */}
          </div>
        </div>
        {step === 1 && (
          <div className={classes.aboutInsure}>
            <div className={classes.aboutInsureTitle}>О страховке:</div>
            <div className={classes.aboutInsureItem}>
              <img src={games} alt="games" />
              {insurance.sports.map((x) => x.title).join(", ") ||
                "Добавьте спорт"}
            </div>
            <div className={classes.aboutInsureItem}>
              <img src={calendar} alt="calendar" />
              {moment(insurance.startDate).format("DD-MM-YYYY")} -{" "}
              {moment(insurance.expirationDate).format("DD-MM-YYYY")}
            </div>

            <div className={classes.aboutInsureItem}>
              <img src={helmet} alt="helmet" />
              {insurance.packet.title}
            </div>
            <p onClick={() => changeStep(0)}>Изменить</p>
          </div>
        )}
        <div className={classes.insurance}>
          <div className={classes.insuranceDescription}>
            <p>
              При покупке этого страхового полиса, вы также получаете бесплатную
              страховку для следующих видов спорта:
            </p>
          </div>
          <div className={classes.insuranceItems}>
            <ul
              className={cs(
                classes.insuranceItemsUl,
                !sportsHidded && classes.insuranceItemsUlOpened
              )}
            >
              {sortedSports.map((x) => (
                <li key={x.id} onClick={() => changeStep(0)}>
                  {x.title}
                </li>
              ))}
            </ul>
            {insurance.sports.length > 6 ? (
              <Button
                classes={{
                  root: cs(
                    classes.sidebarBlueButton,
                    !sportsHidded && classes.deleteDots
                  ),
                }}
                onClick={() => {
                  hideSports(!sportsHidded);
                }}
              >
                {sportsHidded
                  ? `Остальные ${insurance.sports.length}`
                  : "Скрыть"}
                <ArrowDown
                  classes={{
                    root: sportsHidded ? classes.arrowDown : classes.arrowUp,
                  }}
                />
              </Button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
